export default __webpack_public_path__ + "static/benxoa-43c7a39c869d486590ab12d35da4d21a.jpg";